import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    TextField,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Autocomplete,
    Stack,
    IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DataGrid } from "@mui/x-data-grid";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { CommonDeleteButton, CommonEditButton } from "../../../Components/Common Components/CommonComponents";
import { ImagePaths } from "../../../Utility/ImagePaths";
import { CheckAccessFunc, ContentInTooltip, GetStoreBaseUrl } from "../../../Components/CommonFunctions/CommonFunctions";
import Loader from "../../../Components/Loader";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTime } from "luxon";
import CommonValidation from "../../../Components/CommonFunctions/CommonValidation";

const ProductManagement = () => {
    const history = useHistory();
    const location = useLocation();
    const [expanded, setExpanded] = useState(false);
    const [fromWantedList, setfromWantedList] = useState(location.states?.from_wanted_list || false);
    const [vendorList, setvendorList] = useState([]);
    const [categoryList, setcategoryList] = useState([]);
    const [subCategoryList, setsubCategoryList] = useState([]);
    const [departmentList, setdepartmentList] = useState([]);
    const [productTypeList, setProductTypeList] = useState([]);
    const [productList, setProductList] = useState([]);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [PruchaseReqData, setPruchaseReqData] = useState([]);
    const [DeletedLineItmIds, setDeletedLineItmIds] = useState([]);
    const [EditID, setEditID] = useState(null);
    const [RequestEditID, setRequestEditID] = useState(null);
    const [RequestItemId, setRequestItemId] = useState(null);
    const [vendorName, setvendorName] = useState(null);
    const [gst, setgst] = useState('');
    const [prDate, setPrDate] = useState(new Date());
    const [postBtnDisble, setPostBtnDisble] = useState(false);
    const [isloader, setisloader] = useState(false);


    const [formData, setFormData] = useState({
        product_details: null,
        department_details: null,
        category_details: null,
        sub_category_details: null,
        product_type_details: null,
        modelSerialNo: "",
        hsnCode: "",
        quantity: "",
    });


    useEffect(() => {
        if (postBtnDisble) {
            postPurchaseRequest()
        }
    }, [postBtnDisble])

    const columns = [
        { field: "product_code", headerName: "Product Code", flex: 0.1 },
        { field: "product_name", headerName: "Product Details", flex: 0.1 },
        { field: "department_name", headerName: "Department", flex: 0.1 },
        { field: "category_name", headerName: "Category", flex: 0.1 },
        { field: "sub_category_name", headerName: "Sub Category", flex: 0.1 },
        { field: "product_type_name", headerName: "Product Type", flex: 0.1 },
        { field: "modelSerialNo", headerName: "Model/Serial No", flex: 0.1 },
        { field: "hsnCode", headerName: "HSN Code", flex: 0.1 },
        { field: "quantity", headerName: "Quantity", flex: 0.1 },
        {
            field: "action", headerName: "Action", flex: 0.1,
            renderCell: (params) => (
                <Stack direction="row" alignItems="center" spacing={4}>
                    <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
                        <CommonEditButton
                            disabled={params.row.product_id === null}
                            size="1.5vw" onClick={() => {
                                let ProductData = productList?.find((item) => item?.id === (params.row.productID || params.row.product_id))
                                setFormData({
                                    product_details: ProductData,
                                    department_details: params.row?.department_name,
                                    category_details: params.row?.category_name,
                                    sub_category_details: params.row?.sub_category_name,
                                    product_type_details: params.row?.product_type_name,
                                    modelSerialNo: ProductData?.model_no ? ProductData?.model_no : "",
                                    hsnCode: ProductData?.hsn_code ? ProductData?.hsn_code : "",
                                    quantity: params.row.quantity ? params.row.quantity : "",
                                    id: params.row.id ? params.row.id : null,
                                });
                                setRequestItemId(params?.id ? (params?.id - 1) : null)
                                setExpanded(true)
                            }} />
                        <CommonDeleteButton size="1.5vw" onClick={() => {
                            let DataList = [...PruchaseReqData]
                            DataList.splice(params.api.getRowIndex(params.id), 1)
                            if (params.row.id) {
                                let DeletedLineIds = DeletedLineItmIds
                                DeletedLineIds.push(params.row.id)
                                setDeletedLineItmIds(DeletedLineIds)
                            }
                            setPruchaseReqData(DataList)
                        }} />
                    </Stack>
                </Stack>)
        },
    ];

    useEffect(() => {
        getSubCategoryList()
        getCategoryList()
        getVendorList(location.states?.vendor_id ? location.states?.vendor_id : null)
        getdepartmentList()
        getProductType()
        getProductList((location.states?.line_items ? location.states.line_items : null), location.states?.vendor_id ? location.states?.vendor_id : null)

        if (location.states) {
            setEditID(location.states.id)
            setRequestEditID(location.states.purchase_request_id)
            setPrDate(location.states?.request_date ? DateTime.fromISO(location.states?.request_date).toFormat('yyyy-MM-dd') : new Date())
            setgst(location.states?.gst_number ? location.states?.gst_number : "")
        }
    }, [])

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    const errorMessage = (msg) => {
        setPostBtnDisble(false)
        setisloader(false)
        seterrorMsgText(msg)
        seterrorMsg(true)
    }

    const successMessage = (msg) => {
        setPostBtnDisble(false)
        setisloader(false)
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    const getCategoryList = () => {
        try {
            RestAPIService.getAll(Serviceurls.STORE_CATEGORY)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setcategoryList(response.data.data?.filter((item) => item?.is_active) || [])
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const getVendorList = (VendorId = null) => {
        try {
            RestAPIService.getAll(Serviceurls.STORE_VENDOR)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setvendorList(response.data.data?.filter((item) => item?.is_active) || [])
                        if (VendorId) {
                            setvendorName(response.data.data?.find((item) => item?.id === VendorId))
                            setgst(response.data.data?.find((item) => item?.id === VendorId)?.gst_no || "")
                        }
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const getdepartmentList = () => {
        try {
            RestAPIService.getAll(Serviceurls.STORE_DEPARTMENT)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setdepartmentList(response.data.data?.filter((item) => item?.is_active) || [])
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const getSubCategoryList = () => {
        try {
            RestAPIService.getAll(Serviceurls.STORE_SUB_CATEGORY)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setsubCategoryList(response.data.data?.filter((item) => item?.is_active) || [])
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const getProductType = () => {
        try {
            RestAPIService.getAll(Serviceurls.STORE_PRODUCT_TYPE)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setProductTypeList(response.data.data?.filter((item) => item?.is_active) || [])
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const getProductList = (LineItems = [], VendorId = null) => {
        try {
            RestAPIService.getAll(Serviceurls.STORE_SUBLOC_PRODUCT_LIST + (VendorId ? `?vendor_id=${VendorId}` : ""))
                .then((response) => {
                    if (response.data.status === 'success') {
                        let List = (response.data?.data || [])
                            .filter(item => item?.is_active)
                            .map(item => ({
                                ...item,
                                display_key: `${item.product_name} | ${item.product_code} | ${item.department_name} | ${item.category_name} | ${item.sub_category_name} | ${item.product_type_name}`
                            }));
                        setProductList(List)
                        if (LineItems?.length) {
                            let data = LineItems
                            let ReqLineItems = []
                            data?.forEach((list) => {
                                let ProductDetails = response.data.data?.find((item) => list?.product_id === item?.id)
                                ReqLineItems?.push({
                                    product_id: ProductDetails?.id || null,
                                    product_name: ProductDetails?.product_name || list?.product_name,
                                    product_code: ProductDetails?.product_code || list?.product_code,
                                    product_details: ProductDetails,
                                    department_name: ProductDetails?.department_name || list?.department_name,
                                    category_name: ProductDetails?.category_name || list?.category_name,
                                    sub_category_name: ProductDetails?.sub_category_name || list?.sub_category_name,
                                    product_type_name: ProductDetails?.product_type_name || list?.product_type_name,
                                    modelSerialNo: ProductDetails?.model_no || list?.model_no,
                                    hsnCode: ProductDetails?.hsn_code || list?.hsn_code,
                                    quantity: +list?.quantity,
                                    id: list?.id
                                })
                            })
                            setPruchaseReqData(ReqLineItems)
                        }
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const postPurchaseRequest = () => {
        try {
            // if (!productType) {
            //     errorMessage('Please Enter Product Type')
            // } else {
            let LineItems = []
            PruchaseReqData?.forEach((list) => {
                LineItems.push({
                    'product_id': list?.product_id,
                    'quantity': +list?.quantity,
                    'id': list?.id || null,
                })
            })
            var date = new Date(prDate);
            var request_date = DateTime.fromJSDate(date).toFormat('yyyy-MM-dd HH:mm:ss');
            let data = {
                'vendor_id': vendorName?.id,
                'request_date': prDate ? request_date : "",
                'line_items': LineItems,
            }
            if (EditID) {
                setisloader(true)
                data["inward_id"] = EditID
                data["request_id"] = RequestEditID
                data["ids_deleted"] = DeletedLineItmIds
                RestAPIService.updateWithOutId(data, Serviceurls.STORE_PURCHASE_REQUEST)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            setPostBtnDisble(false)
                            setisloader(false)
                            history.push({ pathname: fromWantedList ? `/StorePurchase/WantedList` : "/StorePurchase/PurchaseRequest", states: { success_message: response.data.message } })
                        }
                    }).catch(e => {
                        setPostBtnDisble(false)
                        setisloader(false)
                        if (e?.response?.data?.status === 'fail') {
                            errorMessage(e.response.data.message)
                        } else {
                            errorMessage(e.message)
                        }
                    })
            } else {
                setisloader(true)
                RestAPIService.create(data, Serviceurls.STORE_PURCHASE_REQUEST)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            setPostBtnDisble(false)
                            setisloader(false)
                            history.push({ pathname: fromWantedList ? `/StorePurchase/WantedList` : "/StorePurchase/PurchaseRequest", states: { success_message: response.data.message } })
                        }
                    }).catch(e => {
                        setisloader(false)
                        if (e?.response?.data?.status === 'fail') {
                            errorMessage(e.response.data.message)
                        } else {
                            errorMessage(e.message)
                        }
                    })
            }
            // }
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "quantity") {
            if (CommonValidation.numberOnly(value) || value === "") {
                setFormData((prev) => ({ ...prev, [name]: value }));
            }
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };

    const rendertable = () => {
        PruchaseReqData?.forEach((element, index) => element.sno = index + 1)
        return (
            <DataGrid
                rows={PruchaseReqData}
                columns={columns}
                pageSize={5}
                getRowId={(row) => row['sno']}
                hideFooter
                density="compact" />
        )
    }

    return (
        <Box sx={{}}>
            <Box component={'div'} className='eMed_Pharma_Header_Card' sx={{ display: "flex", justifyContent: 'space-between', alignItems: 'center', height: "7dvh" }}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <IconButton size="small" onClick={() => {
                        history.push({ pathname: fromWantedList ? `/StorePurchase/WantedList` : "/StorePurchase/PurchaseRequest" })
                    }} >
                        <img className="emedhub_popupIcon_img" src={ImagePaths.LabBackButton.default} alt={"Back"} />
                    </IconButton>
                    <Typography sx={{ color: "#616161" }}> {`Back to ${fromWantedList ? "Wanted List" : "Purchase Request"}`}</Typography></Stack>
                <Button sx={{ textTransform: 'capitalize' }} size="small" variant="contained" disabled={postBtnDisble} onClick={() => {
                    if (!vendorName) {
                        errorMessage("Select the Vendor")
                    } else if (PruchaseReqData?.length === 0) {
                        errorMessage("Add the Product")
                    } else {
                        setPostBtnDisble(true)
                    }
                }}>{EditID ? "Update Request" : "Raise Request"}</Button>
            </Box>
            {/* Vendor Details */}
            <Box sx={{ height: '78dvh', overflow: 'auto' }}>
                <Box sx={{ margin: '0.5vw' }}>
                    <Box sx={{ display: "flex", alignItems: 'center' }}>
                        <Typography fontSize={"1vw"} gutterBottom sx={{ marginLeft: '0.5vw', marginRight: '1.5vw' }}>
                            Vendor Details
                        </Typography>
                        <Autocomplete
                            options={vendorList}
                            value={vendorName}
                            disabled={PruchaseReqData?.length > 0 || formData?.product_details !== null}
                            getOptionLabel={(option) => option.vendor_name}
                            onChange={(event, newValue) => {
                                if (newValue) {
                                    setvendorName(newValue)
                                    setExpanded(true)
                                    setProductList([])
                                    getProductList([], newValue?.id ? newValue?.id : null)
                                    setgst(newValue?.gst_no)
                                } else {
                                    setvendorName(null)
                                    setgst('')
                                    setExpanded(false)
                                    setProductList([])
                                    setPruchaseReqData([])
                                    setFormData({
                                        product_details: null,
                                        department_details: null,
                                        category_details: null,
                                        sub_category_details: null,
                                        product_type_details: null,
                                        modelSerialNo: "",
                                        hsnCode: "",
                                        quantity: "",
                                    })
                                }
                            }}
                            renderInput={(params) => <TextField {...params} label="Vendor" variant="outlined" size="small" sx={{ width: "20dvw", marginRight: "1vw" }} />}
                        />
                        <TextField
                            label="GST"
                            disabled
                            name="gst"
                            value={gst ? gst : ""}
                            onChange={(e) => {
                                setgst(e.target.value)
                            }}
                            variant="outlined"
                            size="small"
                            sx={{ width: "20dvw", marginRight: "1vw" }} />
                        <Box>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    value={prDate ? prDate : null}
                                    name={"datePicker"}
                                    inputFormat='DD-MM-YYYY'
                                    views={["year", "month", "day"]}
                                    onChange={(newDate) => {
                                        setPrDate(newDate);
                                    }}
                                    disabled={EditID}
                                    maxDate={new Date()}
                                    renderInput={(params) => <TextField
                                        {...params}
                                        label={"PR Date"}
                                        variant="outlined"
                                        disabled={EditID}
                                        onKeyDown={(e) => e.preventDefault()}
                                        sx={{ width: '20dvw' }}
                                        size='small'
                                    />}
                                />
                            </LocalizationProvider>
                        </Box>
                    </Box>
                </Box>

                {/* Product Details Accordion */}
                <Accordion expanded={expanded} disabled={vendorName === null} onChange={() => setExpanded(!expanded)}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography fontSize={"1vw"}>Product Details</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box sx={{ display: "flex", flexWrap: 'wrap', alignItems: 'center' }}>
                            <Autocomplete
                                options={productList}
                                value={formData.product_details}
                                getOptionLabel={(option) => typeof (option) === 'string' ? option : option.display_key}
                                onChange={(event, newValue) => {
                                    if (newValue) {
                                        setFormData((prev) => ({
                                            ...prev,
                                            product_details: newValue,
                                            department_details: newValue?.department_name,
                                            category_details: newValue?.category_name,
                                            sub_category_details: newValue?.sub_category_name,
                                            product_type_details: newValue?.product_type_name,
                                            modelSerialNo: newValue?.model_no ? newValue?.model_no : "",
                                            hsnCode: newValue?.hsn_code ? newValue?.hsn_code : "",
                                        }))
                                    } else {
                                        setFormData({
                                            product_details: null,
                                            department_details: null,
                                            category_details: null,
                                            sub_category_details: null,
                                            product_type_details: null,
                                            modelSerialNo: "",
                                            hsnCode: "",
                                        })
                                    }
                                }}
                                renderInput={(params) => <TextField {...params} label="Search Product" variant="outlined" size="small" sx={{ width: "41dvw", margin: "0.5vw" }} />}
                                renderOption={(props, item) => {
                                    if (typeof (item) === 'object') {
                                        return (
                                            <Box {...props}>
                                                <Box sx={{ display: 'flex', flexDirection: 'column', alignContent: "flex-start" }}>
                                                    <Box sx={{ display: 'flex', flexDirection: "row", alignItems: "center" }}>{ContentInTooltip(item?.product_name, 30, "0.9vw", 600, "0.5vw")} - {ContentInTooltip(item?.product_code, 30, "0.9vw", 500, "0.5vw")} </Box>
                                                    <Box sx={{ display: 'flex', flexDirection: "row", alignItems: "center" }}>{ContentInTooltip(item?.department_name, 30, "0.9vw", 500, "0.5vw")} - {ContentInTooltip(item?.category_name, 30, "0.9vw", 500, "0.5vw")} - {ContentInTooltip(item?.sub_category_name, 30, "0.9vw", 500, "0.3vw")}</Box>
                                                </Box>
                                            </Box>
                                        );
                                    }
                                    return <li {...props}>{typeof (item) === 'string' ? item : item?.product_name}</li>;
                                }}
                            />
                            <Autocomplete
                                options={departmentList}
                                disabled
                                value={formData.department_details}
                                getOptionLabel={(option) => typeof (option) === 'string' ? option : option.department_name}
                                onChange={(event, newValue) => setFormData((prev) => ({ ...prev, department_details: newValue }))}
                                renderInput={(params) => <TextField {...params} disabled label="Department" variant="outlined" size="small" sx={{ width: "20dvw", margin: "0.5vw" }} />}
                            />
                            <Autocomplete
                                disabled
                                options={categoryList}
                                value={formData.category_details}
                                getOptionLabel={(option) => typeof (option) === 'string' ? option : option.category_name}
                                onChange={(event, newValue) => setFormData((prev) => ({ ...prev, category_details: newValue }))}
                                renderInput={(params) => <TextField {...params} disabled label="Category" variant="outlined" size="small" sx={{ width: "20dvw", margin: "0.5vw" }} />}
                            />
                            <Autocomplete
                                disabled
                                options={subCategoryList}
                                value={formData.sub_category_details}
                                getOptionLabel={(option) => typeof (option) === 'string' ? option : option.sub_category_name}
                                onChange={(event, newValue) => setFormData((prev) => ({ ...prev, sub_category_details: newValue }))}
                                renderInput={(params) => <TextField {...params} disabled label="Sub Category" variant="outlined" size="small" sx={{ width: "20dvw", margin: "0.5vw" }} />}
                            />
                            <Autocomplete
                                disabled
                                options={productTypeList}
                                value={formData.product_type_details}
                                getOptionLabel={(option) => typeof (option) === 'string' ? option : option.product_type_name}
                                onChange={(event, newValue) => setFormData((prev) => ({ ...prev, product_type_details: newValue }))}
                                renderInput={(params) => <TextField {...params} disabled label="Product Type" variant="outlined" size="small" sx={{ width: "20dvw", margin: "0.5vw" }} />}
                            />
                            <TextField label="Product Code" name="productDetails" disabled value={formData?.product_details?.product_code ? formData?.product_details?.product_code : ""} onChange={handleChange} variant="outlined" size="small" sx={{ width: "20dvw", margin: "0.5vw" }} />
                            <TextField label="Model/Serial No" name="modelSerialNo" disabled value={formData.modelSerialNo} onChange={handleChange} variant="outlined" size="small" sx={{ width: "20dvw", margin: "0.5vw" }} />
                            <TextField label="HSN Code" name="hsnCode" disabled value={formData.hsnCode} onChange={handleChange} variant="outlined" size="small" sx={{ width: "20dvw", margin: "0.5vw" }} />
                            <TextField label="Quantity *" name="quantity" value={formData.quantity} inputProps={{ maxLength: 4 }} onChange={handleChange} variant="outlined" size="small" sx={{ width: "20dvw", margin: "0.5vw" }} />
                            <Button sx={{ textTransform: 'capitalize' }} size="small" variant="outlined" onClick={() => {
                                setFormData({
                                    product_details: null,
                                    department_details: null,
                                    category_details: null,
                                    sub_category_details: null,
                                    product_type_details: null,
                                    modelSerialNo: "",
                                    hsnCode: "",
                                    quantity: "",
                                });
                            }}>Clear</Button>
                            <Button sx={{ textTransform: 'capitalize', marginLeft: "0.5vw" }} size="small" variant="contained" onClick={() => {
                                if (!formData?.product_details) {
                                    errorMessage("Select the Product")
                                } else if (!formData?.quantity) {
                                    errorMessage("Enter the Quantity")
                                } else if (PruchaseReqData?.some((list, index) => (list?.product_id === formData?.product_details?.id && RequestItemId !== index))) {
                                    errorMessage(`${formData?.product_details?.product_name} Already added !`)
                                } else {
                                    let PurchaseRequest = {
                                        product_id: formData?.product_details?.id,
                                        product_name: formData?.product_details?.product_name,
                                        product_code: formData?.product_details?.product_code,
                                        product_details: formData?.product_details,
                                        department_name: formData?.department_details,
                                        category_name: formData?.category_details,
                                        sub_category_name: formData?.sub_category_details,
                                        product_type_name: formData?.product_type_details,
                                        modelSerialNo: formData?.modelSerialNo,
                                        hsnCode: formData?.hsnCode,
                                        quantity: +formData?.quantity,
                                        id: formData?.id || null
                                    }
                                    if (RequestItemId !== null) {
                                        let DataList = [...PruchaseReqData]
                                        DataList[RequestItemId] = PurchaseRequest
                                        setPruchaseReqData(DataList)
                                        setRequestItemId(null)
                                    } else {
                                        let DataList = [...PruchaseReqData, PurchaseRequest]
                                        setPruchaseReqData(DataList)
                                    }
                                    setFormData({
                                        product_details: null,
                                        department_details: null,
                                        category_details: null,
                                        sub_category_details: null,
                                        product_type_details: null,
                                        modelSerialNo: "",
                                        hsnCode: "",
                                        quantity: "",
                                    });
                                }
                            }}>Add</Button>
                        </Box>
                    </AccordionDetails>
                </Accordion>
                <Box sx={{ height: "100%", marginTop: "20px" }}>
                    {rendertable()}
                </Box>
            </Box>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {isloader ? <Loader loaderOpen={isloader} /> : null}

        </Box>
    );
};

export default ProductManagement;
